import { type Psbt, Transaction, address } from 'bitcoinjs-lib';

type ExtractAddressFromInputParams = {
  index: number;
  input: Psbt['data']['inputs'][0];
  psbt: Psbt;
};

/**
 * This method extracts the address from the input data of the psbt.
 * The address is stored as script (Buffer) in either the witnessUtxo or nonWitnessUtxo as an output
 */
export const extractAddressFromInput = ({
  index,
  input,
  psbt,
}: ExtractAddressFromInputParams): string | undefined => {
  let extractedAddress: string | undefined;

  try {
    if (input.witnessUtxo?.script) {
      extractedAddress = address.fromOutputScript(input.witnessUtxo.script);
    }

    if (input.nonWitnessUtxo) {
      const nonWitnessTxn = Transaction.fromBuffer(input.nonWitnessUtxo);
      const txOut = nonWitnessTxn.outs[psbt.txInputs[index].index];

      extractedAddress = address.fromOutputScript(txOut.script);
    }

    return extractedAddress;
  } catch {
    return extractedAddress;
  }
};
